import { evolve } from "@/icons";
import { cn } from "@/lib/utils";
import { useTranslation } from "@repo/shared/i18n";

interface EvolutionsButtonProps {
  disabled: boolean;
  onClick: () => void;
  small?: boolean;
}

export const EvolutionsButton = ({
  disabled,
  onClick,
  small,
}: EvolutionsButtonProps) => {
  const { t } = useTranslation("players");
  return (
    <button
      className={cn(
        "h-9 touch-device:h-7 py-1.5 px-3 text-evolution-secondary rounded text-sm flex flex-row items-center gap-2",
        disabled
          ? "text-dark-disabled bg-disabled cursor-not-allowed"
          : "bg-evolution-hover hover:bg-evolution-active",
        !disabled && "shadow-button",
      )}
      disabled={disabled}
      onClick={() => {
        if (!disabled) {
          onClick();
        }
      }}
    >
      {!small && <span>{t("detailed.evolutions.evoBuilder")}</span>}
      <div className="w-4 h-4">{evolve}</div>
    </button>
  );
};
